export const GET_AUDIT_TRAIL_REQUEST = 'AUDIT_TRAIL/GET_REQUEST';
export const GET_AUDIT_TRAIL_SUCCESS = 'AUDIT_TRAIL/GET_SUCCESS';
export const GET_AUDIT_TRAIL_ERROR = 'AUDIT_TRAIL/GET_ERROR';
